import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { Kicker, Reveal } from "@/components/Reveal";
import Marquee from "@/components/Marquee";
import CtaBand from "@/components/CtaBand";
import { MARQUEE_ITEMS, SERVICES } from "@/data/site";
import { useSiteData } from "@/context/SiteData";
import { usePageMeta } from "@/lib/meta";

export default function Services() {
  usePageMeta(
    "Services | Diamond's Divine Arts",
    "Original artwork, custom commissions, one-on-one consultations, and fine art prints from Diamond's Divine Arts."
  );
  const { t } = useSiteData();

  return (
    <>
      <section className="divine-rays relative overflow-hidden pb-20 pt-16 md:pb-28 md:pt-24" data-testid="services-hero">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <Reveal>
            <Kicker>Services</Kicker>
            <h1 className="mt-6 max-w-3xl font-serif text-4xl font-light leading-[1.08] tracking-tight text-[#1C1815] sm:text-5xl lg:text-6xl">
              What the studio <span className="italic text-[#9A7A3F]">offers</span>
            </h1>
            <p className="mt-6 max-w-2xl text-base font-light leading-relaxed text-[#4A423A]">
              Four ways to bring faith-inspired art into your life — from collecting an original
              to commissioning something entirely your own.
            </p>
          </Reveal>
        </div>
      </section>

      <Marquee items={MARQUEE_ITEMS} />

      <section className="py-20 md:py-32" data-testid="services-list-section">
        <div className="mx-auto max-w-7xl space-y-16 px-4 sm:px-6 lg:px-8">
          {SERVICES.map((s, i) => (
            <Reveal key={s.number}>
              <div
                className={`grid items-start gap-10 border-t border-[#D4AF37]/30 pt-12 lg:grid-cols-12 ${
                  i % 2 === 1 ? "" : ""
                }`}
                data-testid={`service-block-${s.number}`}
              >
                <div className="lg:col-span-5">
                  <span className="font-serif text-6xl font-light text-[#D4AF37]/50">{s.number}</span>
                  <h2 className="mt-4 font-serif text-3xl font-normal tracking-tight text-[#1C1815]">
                    {s.title}
                  </h2>
                  <p className="mt-4 text-base font-light leading-relaxed text-[#4A423A]">
                    {t(`service_desc_${i + 1}`, s.description)}
                  </p>
                </div>
                <div className="lg:col-span-4">
                  <ul className="space-y-3">
                    {s.features.map((f) => (
                      <li key={f} className="flex items-center gap-3 text-sm text-[#3D352E]">
                        <span className="flex h-6 w-6 items-center justify-center rounded-full border border-[#D4AF37]/50">
                          <Check className="h-3 w-3 text-[#9A7A3F]" />
                        </span>
                        {f}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="lg:col-span-3 lg:text-right">
                  <Link
                    to={s.number === "04" ? "/portfolio" : "/booking"}
                    className="btn-outline"
                    data-testid={`service-cta-${s.number}`}
                  >
                    {s.number === "04" ? "Browse Prints" : "Book a Consultation"}{" "}
                    <ArrowRight className="h-4 w-4" />
                  </Link>
                </div>
              </div>
            </Reveal>
          ))}

        </div>
      </section>

      <CtaBand
        title="Not Sure Where to Begin?"
        copy="Book a one-on-one consultation — a relaxed conversation about your vision, your space, and what's possible."
      />
    </>
  );
}
